import { getRequest } from '@/core';
import { deviations } from '@/requests';

export default async function getDeviationStatusesRequest(id) {
	let url = deviations.getDeviationStatusesPath(id);
	let response = await getRequest(url);
	return response;
}
